import { createFileRoute } from "@tanstack/react-router";

import CreateRoundScorePage from "~/pages/game/CreateRoundScorePage";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/games/$gameId/rounds/")({
    component: CreateRoundScorePage,
});
